export class Area {
    Id: number;
    Name: string;
    BusinessUnitID: number;
    IsActive: boolean;
}
